import { withAuthenticationRequired } from '@auth0/auth0-react'
import { NotFound } from 'modules/NotFound'
import { Route, Routes } from 'react-router'
import { FullPage, ModalPage } from '../../components/layout'
import { useIsIFramed } from '../../hooks'
import { Resources } from './Resources'
import { Shops } from './Shops'

const Page = () => {
  const isIFramed = useIsIFramed()
  const [Page, styles] = isIFramed ? [ModalPage, { padding: 0 }] : [FullPage, undefined]

  return (
    <Page style={styles}>
      <Routes>
        <Route element={<Resources />} path="resources/*" />
        <Route element={<Shops />} path="shops/*" />
        <Route element={<NotFound />} path="*" />
      </Routes>
    </Page>
  )
}

const Settings = withAuthenticationRequired(Page)

export { Settings }
